import * as React from 'react';
import { Routes, Route } from 'react-router-dom';

import QuestionnaireManagement from '../Questionnaires/QuestionnaireManagement';
import Questionnaire from '../Questionnaires/Questionnaire';
import Domain from '../Domains/Domain';
import Topic from '../Topics/Topic';
import BestPractice from '../BestPractices/BestPractice';
import Certifications from '../Topics/Certifications';

/**
 * Questionnaire management rendered as an Admin section: the management list and
 * its questionnaire → domain → topic → best-practice drill-down, mounted under
 * /admin/questionnaires so the Admin sub-nav frame stays in place. Paths are
 * relative to that section route.
 */
export default function QuestionnairesAdminPanel() {
  return (
    <Routes>
      <Route path="" element={<QuestionnaireManagement />} />
      <Route path="certifications" element={<Certifications />} />
      <Route path=":questionnaireSlug" element={<Questionnaire />} />
      <Route path=":questionnaireSlug/:domainSlug" element={<Domain />} />
      <Route path=":questionnaireSlug/:domainSlug/:topicSlug" element={<Topic />} />
      <Route path=":questionnaireSlug/:domainSlug/:topicSlug/:bestPracticeSlug" element={<BestPractice />} />
    </Routes>
  );
}
